import {
  FILES_REQUIREMENTS_HEIGHT,
  FILES_REQUIREMENTS_SUPPORTED_FORMATS,
  FILES_REQUIREMENTS_TYPE,
  FILES_REQUIREMENTS_WIDTH,
  initialFileSpecifications
} from '../../../MediaProducts/MediaProductForms/MediaProductCreate/MediaProductCreateForm/fields'

const comparisonKeys = [
  FILES_REQUIREMENTS_TYPE,
  ...Object.keys(initialFileSpecifications),
  FILES_REQUIREMENTS_WIDTH,
  FILES_REQUIREMENTS_HEIGHT,
  FILES_REQUIREMENTS_SUPPORTED_FORMATS
]

function compareRequirementValues(a, b) {
  // Returns true if both values are falsy (excluding 0).
  // 0 is only considered equal to 0.
  // Otherwise uses a strict equality check.

  if (a === 0 || b === 0) {
    return a === b
  }

  if (!a && !b) {
    return true
  }

  return a === b
}

export const compareFileRequirements = (selectedFileRequirements, mediaFileRequirements) => {
  // selectedFileRequirements and mediaFileRequirements are objects, each object field should be equal, all fields
  return comparisonKeys.every(key => {
    // some of the fields are arrays, and we need to check if the arrays values are the same
    const isArray = Array.isArray(selectedFileRequirements[key])

    if (isArray) {
      // supported_file_types, width, height and etc. are array, need to check if the arrays values are the same
      const selectedFileTypes = [...selectedFileRequirements[key]].sort()
      const mediaFileTypes = [...mediaFileRequirements[key]].sort()
      return selectedFileTypes.join(',') === mediaFileTypes.join(',')
    } else {
      return compareRequirementValues(selectedFileRequirements[key], mediaFileRequirements[key])
    }
  })
}

export const checkIsPdfOnly = supportedFileTypes => {
  // check if only one file type is supported and it is pdf
  return supportedFileTypes?.length === 1 && supportedFileTypes.includes('pdf')
}
